import React, { useState, useMemo, useEffect } from "react";
import Menu from "../../../../components/layout/menu/index";
import '../../../../../src/index.css'
import ListFilterATCAdmin from "../../../../components/filters/atcAdminFilters";
import ResetFilters from "../../../../components/filters/resetFilters";
import DynamicTable from "../../../../components/tables/oc/provider/dynamicTable";
import { format } from 'date-fns';
import FilterInput from "../../../../components/filters/filterInput";
import { getListAtc, exportExcelAdmin } from "../../../../client/atc/index"
import DownloadDocumentButton from "../../../../components/shared/downloadDocument";
import ModalAlertWarning from "../../../../components/shared/modals/modalAlertWarning";

  const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    }, [value, delay]);

    return debouncedValue;
  };

const statusIdToNameMapping = {
  13: 'Vacío',
  9: 'Observado',
  15: 'Cancelado',
  14: 'Rech.2da.aprob.',
  18: 'Rech.1ra.aprob.',
  16: 'Pend.1ra.aprob.',
  17: 'Pend.2da.aprob.',
  4: 'Aprobado'
};

const statusColors = {
  'Vacío': '#00A3E0',
  'Observado': '#E44949',
  'Observados': '#E44949', 
  'Cancelado': '#E44949',
  'Rech.2da.aprob.': '#E44949',
  'Rech.1ra.aprob.': '#E44949',
  'Pend.2da.aprob.': '#FFB81C',
  'Pend.1ra.aprob.': '#FFB81C',
  'Aprobado': '#43B02A',
};

const liberationStatusColors = {
  'Liberado': '#43B02A',
  'No Liberado': '#E44949'
};

const generalStatusColors = {
'Pendiente de Llenado de ATC' : '#E44949',
'Pendiente de Creacion de OC' : '#00A3E0',
'Pendiente de Liberacion de Solped' : '#00A3E0',
'Pendiente de Liberacion de OC'  : '#00A3E0',
'Pendiente de HES'       : '#00A3E0',
'Pendiente de Facturación'      : '#FF6900',
'Cerrado / Culminado'       : '#00A3E0',
'Pendiente de Aprobación de ATC'    : '#00A3E0',    
};

const getStatusName = (statusId, statusNameFromApi) => {
  if (statusId && statusIdToNameMapping[statusId]) {
    return statusIdToNameMapping[statusId];
  }
  return statusNameFromApi || 'Sin Estado';
};

const getStatusColor = (statusId, statusNameFromApi) => {
  const statusName = getStatusName(statusId, statusNameFromApi);
  return statusColors[statusName] || '#6B7280';
};

<style>
{`
.table-simplebar .simplebar-scrollbar {
background: #007696;
border-radius: 20px;
width: 5px;
}

.table-simplebar .simplebar-scrollbar:before {
background: #007696 !important;
}
`}
</style>

export default function ATCAdmin() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);

  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);

  const [resetFlag, setResetFlag] = useState(false);

  const [searchTerm, setSearchTerm] = useState('');

  const [downloading, setDownloading] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState('');

  const [showModalAlertWarning, setShowModalAlertWarning] = useState(false);
  const [modalErrorMessage, setModalErrorMessage] = useState('');


const getDefaultDateRange = () => {

  return {
    startDate: '',
    endDate: ''
  };
};

/*
const atcFilterOptions = [
  { title: "Unidad de negocio:" },
  { title: "Número de ATC:" },
  { title: "Número de OT:" },
  { title: "Número de grafo:" },
  { title: "Fecha de creación:" },
  { title: "Embarcación:" },
  { title: "Estado ATC:" },
  { title: "Estado Cotización:" },
  { title: "Número Solped:" },
  { title: "Estado de Solped:" },
  { title: "Estado de HES:" },
  { title: "Supervisor de mantenimiento:" },
  { title: "Tipo de mantenimiento:" },
  { title: "Subtipo de mantenimiento:" },
];
*/
  
const [tempFilters, setTempFilters] = useState({
  unidadNegocio: [], // businessUnits
  numeroATC: [], // atcNumbers (array para múltiple)
  numeroOT: [], // otNumbers (array para múltiple)
  numeroGrafo: [], // graphNumbers
  centers: [], // embarcacion ( centers)
  estadoATC: [], // statusIds
  estadoGeneral: [], // statusGeneralIds
  estadoCotizacion: [], // priceStatuses
  numeroSolped: [], // solpedNumbers
  estadoSolped: [], // solpedStatuses (booleans)
  estadoHES: [], // hesStatuses (booleans)
  supervisor: [], // supervisorsList
  tipoMantenimiento: [], // workTypes
  subtipoMantenimiento: [], // subtypeIds
  creationDateFrom: '', // emissionDateFrom
  creationDateTo: '', // emissionDateTo
});

const [activeFilters, setActiveFilters] = useState({
  unidadNegocio: [],
  numeroATC: [],
  numeroOT: [],
  numeroGrafo: [],
  centers: [],
  estadoATC: [],
  estadoGeneral: [],
  estadoCotizacion: [],
  numeroSolped: [],
  estadoSolped: [],
  estadoHES: [],
  supervisor: [],
  tipoMantenimiento: [],
  subtipoMantenimiento: [],
  creationDateFrom: '',
  creationDateTo: '',
});



  const debouncedSearchTerm = useDebounce(searchTerm, 500);


const fetchData = async () => {
  try {
    setLoading(true);
    
    const filters = {
      emissionDateFrom: activeFilters.creationDateFrom || undefined,
      emissionDateTo: activeFilters.creationDateTo || undefined,
      statusIds: activeFilters.estadoATC.length > 0 ? activeFilters.estadoATC.map(id => parseInt(id)) : undefined,
      priceStatuses: activeFilters.estadoCotizacion.length > 0 ? activeFilters.estadoCotizacion : undefined,
      solpedNumbers: activeFilters.numeroSolped.length > 0 ? activeFilters.numeroSolped : undefined,
      atcNumbers: activeFilters.numeroATC.length > 0 ? activeFilters.numeroATC : undefined,
      otNumbers: activeFilters.numeroOT.length > 0 ? activeFilters.numeroOT : undefined,
      supervisorsList: activeFilters.supervisor.length > 0 ? activeFilters.supervisor : undefined,
      businessUnits: activeFilters.unidadNegocio.length > 0 ? activeFilters.unidadNegocio : undefined,
      subtypeIds: activeFilters.subtipoMantenimiento.length > 0 ? activeFilters.subtipoMantenimiento : undefined,
      workTypes: activeFilters.tipoMantenimiento.length > 0 ? activeFilters.tipoMantenimiento : undefined,
      solpedStatuses: activeFilters.estadoSolped.length > 0 ? activeFilters.estadoSolped : undefined,
      hesStatuses: activeFilters.estadoHES.length > 0 ? activeFilters.estadoHES : undefined,
      graphNumbers: activeFilters.numeroGrafo.length > 0 ? activeFilters.numeroGrafo : undefined,
      searchAtcNumber: debouncedSearchTerm ? debouncedSearchTerm : undefined,
      centers: activeFilters.centers.length > 0 ? activeFilters.centers : undefined,
      statusGeneralIds: activeFilters.estadoGeneral.length > 0 ? activeFilters.estadoGeneral.map(id => parseInt(id)) : undefined,
      };

    
    const response = await getListAtc(currentPage, recordsPerPage, filters);
    
    const dataArray = response.atcs || response.data || [];
    
    const mappedData = dataArray.map((atc, index) => ({
      displayId: (currentPage - 1) * recordsPerPage + index + 1,
      id: atc.id,
      numeroATC: atc.atc_numero,
      estado: atc.lastStatus,  
      estadoId: atc.lastStatusId,
      estadoColor: getStatusColor(atc.lastStatusId, atc.lastStatus),
      centro: atc.centro,
      nroSolped: atc.solped_numero,
      nroOT: atc.ot_numero,
      otPos: atc.ot_pos,
      grafoOpe: atc.grafo_ope,
      ubiTecnica: atc.ubicacion_tecnica,
      resumenTrabajo: atc.atc_resumen,
      fechaCreacion: atc.fecha_creacion ? atc.fecha_creacion.split('T')[0] : '',
      aprobador1: atc.aprobador_1,
      aprobador2: atc.aprobador_2,
      usuarioMaximo: atc.usuario_maximo,
      hesMax: atc.hesMax_numero,
      solped: atc.solped_numero,
      estadoSolped: atc.solped_liberado, //liberado - no liberado
      oc: atc.oc_numero,
      posOC: atc.oc_posicion, //liberado - no liberado
      estadoOC: atc.oc_liberado,
      responsableHESSAP: atc.supervisor,
      estadoHes: atc.hesSap_liberado,
      tipoTrabajo: atc.typeName,
      subtipoTrabajo: atc.subtypeName,
      regularizacion: atc.regularizacion,
  responsableOc: Array.isArray(atc.oc_responsible) 
    ? atc.oc_responsible.join(', ') 
    : atc.oc_responsible || '', 

      getStatusColor: () => getStatusColor(atc.lastStatusId, atc.lastStatus),

      fechaLiberacion: atc.solpedInfo?.position?.liberation_date,

      unidadNegocio: atc.unidad_negocio,

      estadoGeneralServicio: atc.status_general_description,
    }));

    setAllData(mappedData);
    setTotalRecords(response.totalCount || 0);
    
  } catch (err) {
    console.error('Error fetching ATC data:', err);
    setError(err.message || "Error al cargar los datos");
  } finally {
    setLoading(false);
  }
};

const handleSearchChange = (value) => {
  setSearchTerm(value);
  setCurrentPage(1); 
};

  useEffect(() => {
    fetchData();
  }, [activeFilters, currentPage, recordsPerPage, debouncedSearchTerm]);

  const tableConfig = {
    headers: [
      "#",
      "Número ATC",
      "Estado general del servicio",
      "Estado de ATC",
      "Centro",
      "Unidad de negocio",
      "Nro. Solped",
      "Número OT",
      "OT / POS",
      "Grafo / Ope",
      "Ubi.Técnica",
      "Resumen del trabajo",
      "Fecha de creación",
      "Aprobador 1",
      "Aprobador 2",
      "Usuario Máximo",
      "HES _ MAX",
      "Estado de Solped",
      "Fecha de liberación",
      "Responsable de OC",
      "OC",
      "POS de OC",
      "Estado de OC",
      "Responsable de HES-SAP",
      "Estado de HES",
      "Tipo de mantenimiento",
      "Subtipo de mantenimiento",
      "Regularización"
    ],
    accessors: [
      "displayId", //#
      "numeroATC", //Número de ATC
      "estadoGeneralServicio", // Estado general del servicio
      "estado", // Estado
      "centro", //Centro
      "unidadNegocio", //Unidad de negocio
      "nroSolped", //Nro. Solped
      "nroOT", // Número OT
      "otPos", //OT / POS
      "grafoOpe", //Grafo / Ope
      "ubiTecnica", //Ubi. Técnica
      "resumenTrabajo", //Resumen de trabajo
      "fechaCreacion", // Fecha de creación
      "aprobador1", // Aprobador 1
      "aprobador2", // Aprobador 2
      "usuarioMaximo", // Usuario máximo
      "hesMax", // HES _ MAX
      "estadoSolped", // Estado de Solped 
      "fechaLiberacion", // Fecha de liberación
      "responsableOc", // Responsable de OC
      "oc", // OC
      "posOC", // POS de OC
      "estadoOC", // Estado de OC
      "responsableHESSAP", // Responsable de HES-SAP
      "estadoHes", // Estado de HES
      "tipoTrabajo", // Tipo de trabajo
      "subtipoTrabajo", // Subtipo de trabajo
      "regularizacion" // Regularizacion

    ],
    widths: [
      "46px", //#
      "111px", //Número de ATC
      "142px", // Estado general del servicio 
      "142px", // Estado
      "111px", //Centro
      "111px", //Unidad de negocio
      "128px", //Nro. Solped
      "111px", // Número OT 
      "111px", //OT / POS
      "112px", //Grafo / Ope
      "260px", //Ubi. Técnica
      "260px", //Resumen de trabajo
      "112px", // Fecha de creación
      "169px", // Aprobador 1
      "169px", // Aprobador 2
      "169px", // Usuario máximo
      "155px", // HES _ MAX
      "115px", // Estado de Solped 
      "112px", // Fecha de liberación
      "232px", // Responsable de OC
      "128px", // OC
      "128px", // POS de OC
      "115px", // Estado de OC
      "231px", // Responsable de HES-SAP
      "115px", // Estado de HES
      "151px", // Tipo de trabajo
      "167px", // Subtipo de trabajo
      "137px" // Regularizacion
    ]
  };


  const totalPages = Math.ceil(totalRecords / recordsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


const handleFilterChange = (filterTitle, value) => {
  const filterMap = {
    "Unidad de negocio:": "unidadNegocio",
    "Número de ATC:": "numeroATC",
    "Número de OT:": "numeroOT",
    "Número de grafo:": "numeroGrafo",
    "Embarcación:": "centers",
    "Estado ATC:": "estadoATC",
    "Estado general del servicio:": "estadoGeneral",
    "Estado Cotización:": "estadoCotizacion",
    "Número Solped:": "numeroSolped",
    "Estado de Solped:": "estadoSolped",
    "Estado de HES:": "estadoHES",
    "Supervisor de mantenimiento:": "supervisor",
    "Tipo de mantenimiento:": "tipoMantenimiento",
    "Subtipo de mantenimiento:": "subtipoMantenimiento",
  };

  const filterKey = filterMap[filterTitle];
  if (filterKey) {
    setTempFilters(prev => ({
      ...prev,
      [filterKey]: value
    }));
  }
};

const handleDateRangeChange = ({ startDate, endDate }) => {
  setTempFilters(prev => ({
    ...prev,
    creationDateFrom: startDate || '',
    creationDateTo: endDate || ''
  }));
};

  const applyFilters = () => {
    setActiveFilters({ ...tempFilters });
    setCurrentPage(1); 
  };

  const handleResetFilters = () => {

    const resetFilters = {
    numeroATC: [],
    unidadNegocio: [],
    numeroOT: [],
    numeroGrafo: [],
    centers: [],
    estadoATC: [],
    estadoGeneral: [],
    estadoCotizacion: [],
    numeroSolped: [],
    estadoSolped: [],
    estadoHES: [],
    supervisor: [],
    tipoMantenimiento: [],
    subtipoMantenimiento: [],
    creationDateFrom: '', 
    creationDateTo: ''
    };
    
    setTempFilters(resetFilters);
    setActiveFilters(resetFilters);
    setSearchTerm('');
    setCurrentPage(1);
    setResetFlag(prev => !prev);
  };

  const handleRecordsCountChange = (e) => {
    const newRecordsPerPage = parseInt(e.target.value);
    setRecordsPerPage(newRecordsPerPage);
    setCurrentPage(1); 
  };

  const showErrorModal = (errorMessage) => {
    setModalErrorMessage(errorMessage);
    setShowModalAlertWarning(true);
  };

  const closeModal = () => {
    setShowModalAlertWarning(false);
    setModalErrorMessage('');
  };

const handleDownloadExcel = async () => {
    try {
      setDownloading(true);
      setDownloadProgress('Preparando archivo...');

      const exportFilters = {
        emissionDateFrom: activeFilters.creationDateFrom || undefined,
        emissionDateTo: activeFilters.creationDateTo || undefined,
        statusIds: activeFilters.estadoATC?.length > 0 ? activeFilters.estadoATC.map(id => parseInt(id)) : undefined,
        priceStatuses: activeFilters.estadoCotizacion?.length > 0 ? activeFilters.estadoCotizacion : undefined,
        solpedNumbers: activeFilters.numeroSolped?.length > 0 ? activeFilters.numeroSolped : undefined,
        atcNumbers: activeFilters.numeroATC?.length > 0 ? activeFilters.numeroATC : undefined,
        otNumbers: activeFilters.numeroOT?.length > 0 ? activeFilters.numeroOT : undefined,
        supervisorsList: activeFilters.supervisor?.length > 0 ? activeFilters.supervisor : undefined,
        businessUnits: activeFilters.unidadNegocio?.length > 0 ? activeFilters.unidadNegocio : undefined,
        subtypeIds: activeFilters.subtipoMantenimiento?.length > 0 ? activeFilters.subtipoMantenimiento : undefined,
        workTypes: activeFilters.tipoMantenimiento?.length > 0 ? activeFilters.tipoMantenimiento : undefined,
        solpedStatuses: activeFilters.estadoSolped?.length > 0 ? activeFilters.estadoSolped : undefined,
        hesStatuses: activeFilters.estadoHES?.length > 0 ? activeFilters.estadoHES : undefined,
        graphNumbers: activeFilters.numeroGrafo?.length > 0 ? activeFilters.numeroGrafo : undefined,
        searchAtcNumber: searchTerm || undefined,
        centers: activeFilters.centers?.length > 0 ? activeFilters.centers : undefined,
        statusGeneralIds: activeFilters.estadoGeneral?.length > 0 ? activeFilters.estadoGeneral.map(id => parseInt(id)) : undefined,
      };

      setDownloadProgress('Descargando archivo...');

      const response = await exportExcelAdmin(exportFilters);
      
      const blob = new Blob([response.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      const url = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = url;
      link.download = response.fileName; 
      
      document.body.appendChild(link);
      link.click();
      
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);

      setDownloadProgress('Descarga completada');
      
      setTimeout(() => {
        setDownloading(false);
        setDownloadProgress('');
      }, 1500);

    } catch (error) {
      console.error('Error al descargar Excel:', error);
      setDownloadProgress('Error en la descarga');
      
      showErrorModal('Error al descargar el archivo. Por favor, intente nuevamente.');
      
      setTimeout(() => {
        setDownloading(false);
        setDownloadProgress('');
      }, 2000);
    }
  };

  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"}  bg-[#F7F8F9] w-full z-50 min-h-screen`}>
      {/* Overlay de carga para descarga */}
      {downloading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100]">
          <div className="max-w-md p-6 mx-4 bg-white rounded-lg">
            <div className="flex items-center justify-center mb-4">
              <div className="w-12 h-12 border-b-2 rounded-full animate-spin border-blue"></div>
            </div>
            <p className="mb-2 text-center text-gray-700 font-itcmedium">
              Descargando archivo...
            </p>
            <p className="text-sm text-center text-gray-600 font-itcbook">
              {downloadProgress}
            </p>
            <p className="mt-3 text-xs text-center text-gray-500 font-itcbook">
              Por favor espere, este proceso puede tomar varios segundos.
            </p>
          </div>
        </div>
      )}
        
        <div className="md:pt-8 pt-4 pb-10 px-[3%]">
          <div className="flex flex-col justify-between w-full gap-4">
            <div className="flex flex-col items-center justify-between gap-2 md:flex-row">
              <h1 className="text-2xl md:text-[32px] text-blue font-itcbold">
                Mis Actas de Trabajo Culminado
              </h1>
              <div className="flex flex-col items-center gap-6 md:flex-row">
                  <DownloadDocumentButton
                    text="Descargar"
                    onClick={handleDownloadExcel}
                    loading={downloading}
                    hasData={allData.length > 0}
                    disabled={downloading || allData.length === 0}
                  />
                <div className="flex flex-row items-center gap-6 ">
                    <ListFilterATCAdmin
                    titleOption="Filtrar"
                 //   filters={atcFilterOptions}
                    onFilterChange={handleFilterChange}
                    onDateRangeChange={handleDateRangeChange}
                    applyFilters={applyFilters}
                    resetFlag={resetFlag}
                    activeFilters={activeFilters}
                    />
                    <ResetFilters
                      borderColor="border-blue-light"
                      textColor="text-[#6B7280]"
                      font="font-itcbook"
                      onClick={handleResetFilters}
                    />
                </div>
              </div>
            </div>
            <div className="flex flex-col-reverse items-start justify-between gap-2 sm:items-center sm:flex-row">
              <div className="flex items-center space-x-2 text-sm font-itcbook">
                <p >Mostrar</p>
                <div className="border-[#D1D5DB] border-[1px] rounded-md w-[58px] flex justify-center items-center h-[40px]">
                  <select
                    className="w-full h-full px-2 text-sm bg-white rounded-md outline-none cursor-pointer font-itcbook"
                    value={recordsPerPage}
                    onChange={handleRecordsCountChange}  
                  >
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                  </select>
                </div>
                <p >Registros</p>
              </div>
              <FilterInput
                placeholder="Buscar ATC"
                value={searchTerm}
                  onChange={(e) => {
                      const inputValue = e.target.value;
                      if (inputValue === '' || /^[0-9]*$/.test(inputValue)) {
                          handleSearchChange(inputValue)
                      }
                  }}
                classname="sm:w-auto md:w-full"
              />
            </div>
            <DynamicTable
              data={allData}
              config={tableConfig}
              statusColors={statusColors}
              liberationStatusColors={liberationStatusColors}
              generalStatusColors={generalStatusColors}
              currentPage={currentPage}
              totalPages={totalPages}
              recordsPerPage={recordsPerPage}
              totalRecords={totalRecords}
              changePage={handlePageChange}
              loading={loading}
            />
          </div>
        </div>
      </div>
     <ModalAlertWarning 
        showModalAlertWarning={showModalAlertWarning}
        closeModal={closeModal}
        error={modalErrorMessage}
        accept={closeModal}
        color="#CA2D00"
      />
    </div>
  );
}